var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.updateCart = function() {
	if ($(".page-cart-index").length
		// || $(".page-cart-checkout").length
		// || $(".page-offering-index").length
		// || $(".page-offering-checkout").length
		// || $(".page-product-shop").length
		// || $(".page-product-listing").length
		// || $(".page-product-detail").length
		// || $(".page-product-category").length
		// || $(".page-product-category-detail").length
	) {
		const discountEligibleJS = $(".discount-eligible-js");
		const src = $(".page-offering-index").length || $(".page-offering-checkout").length
			? 'offering' : 'cart';
		const adders = [$(".btn-add-cart"), $(".add-your-full-allocation-button .btn")];
		const changers = [$(".qty.form-control"), $(".qty.custom-select")];
		adders.forEach(function(adder) {
			adder.on("click", function() {
				timedUpdateCartQty();
			});
		});
		changers.forEach(function(changer) {
			changer.on("change", function() {
				timedUpdateCartQty();
			});
		});
		$(window).on("load", function() {
			timedUpdateCartQty();
		});

		const updateCartQty = async function() {
		try {
			const res = await fetch(`/${src}/get_config_json/`);
			const json = await res.json();
			console.log({json});
			let count = parseInt(json.discount.count) || 12;
			let qty = 0;
			Object.values(json.cart.items)
				.filter(item => item.product_type === "Wine")
				.forEach(item => {
					qty += parseInt(item.quantity);
				})
			
			// Hide .bg-orange if no wine products, show if there are wine products
			if (qty === 0) {
				$(".bg-orange").hide();
			} else {
				$(".bg-orange").show();
			}
			
			// Update shipping message and active classes
			updateShippingMessage(qty, count);
			updateShippingActive(qty, count);
			
			const qtyInCurrentCase = qty % count || count;
			const progress = Math.round(qtyInCurrentCase / count * 100, 0);
				$(".discount-eligible-progress-js .progress-bar").css("width", `${progress}%`);
				$(".discount-eligible-progress-js .progress-bar").attr("aria-valuenow", qtyInCurrentCase);
				$(".discount-eligible-progress-js .progress-bar").text(`${progress}%`);
				$(".discount-eligible-progress-js").removeClass('d-none');
				if (qty % count === 0 && qty > 0) {
					$(".discount-eligible-js").html(`<p>Your order qualifies for <br><strong>Ground Shipping Included</strong></p>`);
					$(".offering-rules").removeClass("mb-3");
				} else {
					const bottlesNeeded = count - (qty % count);
					$(".discount-eligible-js").html(`<p>Add <strong>${bottlesNeeded}</strong> more bottle${bottlesNeeded > 1 ? 's' : ''} to your cart for <br><span>Ground Shipping Included on 12+ bottles.</span></p>`);
					$(".offering-rules").removeClass("mb-3");
				}
			} catch (error) {
				console.error("Error fetching allocation data:", error);
			}
		}
		const timedUpdateCartQty = function () {
			setTimeout(() => {
				updateCartQty();
			}, 100);
		}

		// <p><strong>Standard Ground Shipping</strong></p>
		// <p><strong>Flat Rate Shipping</strong></p>
		const updateShippingMessage = function(qty, count) {
			const $shippingMessage = $(".shipping-message-js");
			
			if (qty % count === 0 && qty > 0) {
				// Hide for exact multiples of 12 (12, 24, 36, etc.)
				$shippingMessage.hide();
			} else if (qty >= 1 && qty <= 5) {
				// Show Standard Ground Shipping for 1-5 bottles only
				$shippingMessage.html(``).show();
			} else if (qty >= 6) {
				// Show Flat Rate Shipping for 6-11, 13-23, 25-35, etc.
				$shippingMessage.html(``).show();
			} else {
				// Hide if qty is 0 or negative
				$shippingMessage.hide();
			}
		}

		const updateShippingActive = function(qty, count) {
			// Remove all active classes first
			$(".standard, .flat, .free").removeClass("active");
			
			if (qty % count === 0 && qty > 0) {
				// Exact multiples of 12 - activate free shipping
				$(".free").addClass("active");
			} else if (qty >= 1 && qty <= 5) {
				// 1-5 bottles - activate standard
				$(".standard").addClass("active");
			} else if (qty >= 6) {
				// 6+ bottles (except multiples of 12) - activate flat rate
				$(".flat").addClass("active");
			}
		}
	}
}();